<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const titrePrincipal = ref(null)

const props = defineProps({
  modeDepositaire: {
    type: Boolean,
    default: false,
  },
})

onMounted(() => {
  //Mise à jour de la balise <title> pour les lecteurs d'écran (RGAA)
  document.title = props.modeDepositaire
    ? 'Rechargement réussi - Dépositaire - Lulu en bus'
    : 'Merci pour votre rechargement - Lulu en bus'

  if (titrePrincipal.value) {
    titrePrincipal.value.focus()
  }
})
</script>

<template>
  <div v-if="!props.modeDepositaire" class="text-center container">
    <h1 class="py-3 py-sm-5" ref="titrePrincipal" tabindex="-1">
      Merci d'avoir rechargé votre abonnement
    </h1>

    <p>Votre commande n° {{ route.query.numeroCommande }} a été enregistrée.</p>

    <p>
      Le réseau Lulu en bus vous remercie pour votre commande. Un email vient de vous
      être envoyé confirmant votre renouvellement d'abonnement.
    </p>
    <p>Bonne route à bord !</p>

    <address class="coordonnees">
      <strong>Agence de Mobilité Lulu en bus</strong><br />
      3 Pl. Pierre Semard<br />
      54300 Lunéville<br />
      Téléphone : <a href="tel:0800607062">0 800 607 062</a><br />
      Formulaire :
      <a
        href="https://lulu-mobilite.fr/contact/"
        aria-label="Accéder au formulaire de contact de l'agence Lulu en bus"
      >
        Contactez-nous
      </a>
    </address>

    <a class="bouton_valid btn btn-lg" href="https://lulu-mobilite.fr">
      Retour à l'accueil du site Lulu en bus
    </a>
  </div>

  <div v-else class="text-center container">
    <h1 class="py-3 py-sm-5" ref="titrePrincipal" tabindex="-1">
      Rechargement effectué avec succès
    </h1>
    <p>La commande n° {{ route.query.numeroCommande }} a été enregistrée.</p>

    <router-link class="bouton_valid btn btn-lg" to="rechargement">
      Retour au menu Dépositaire
    </router-link>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

.coordonnees {
  margin: 2rem 0;
  font-style: normal;
}

.bouton_valid {
  display: inline-block;
  margin: 2rem auto;
  @include boutons;

  &:hover {
    @include boutons_hover;
  }

  &:focus-visible {
    @include boutons_hover;
    outline: 3px solid #000;
    outline-offset: 2px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
